import React from 'react'
import PropTypes from 'prop-types'

import Select from '../Select'

const LocationSelect = (props) => {
  const {
    required,
    placeholder,
    noResultsText,
    ...otherProps
  } = props

  const selectProps = {
    placeholder,
    noResultsText,
    required,
    ...otherProps
  }

  return (
    <div className='vs-form-location-select'>
      <Select
        virtualized
        {...selectProps}
      />
    </div>
  )
}

LocationSelect.propTypes = {
  /**
   * A placeholder showing when no option is selected
   */
  placeholder: PropTypes.string,
  /**
   * Text to show when there are no locations on the list
   */
  noResultsText: PropTypes.string,
  /**
   * Classname for custom styling of this component
   */
  locationSelectClassName: PropTypes.string
}

LocationSelect.defaultProps = {
  placeholder: 'Type a location name',
  noResultsText: 'No location found'
}

export default LocationSelect
